import {UntypedFormArray, UntypedFormGroup, ValidationErrors, ValidatorFn} from '@angular/forms'

export const atLeastOneSelected =
  (): ValidatorFn =>
  (formArray: UntypedFormArray): ValidationErrors | null => {
    if (!formArray.controls.some(control => control.value)) {
      return {atLeastOneSelected: true}
    }
    return null
  }

export const atLeastOneOptionSelected =
  (): ValidatorFn =>
  (form: UntypedFormGroup): ValidationErrors | null => {
    if (!Object.values(form.value).some(v => !!v)) {
      return {atLeastOneOptionSelected: true}
    }

    return null
  }
